// extracted by mini-css-extract-plugin
export default {"settings":"Settings_settings__P4XDg","options":"Settings_options__DuLui","dark":"Settings_dark__Ts9kI","light":"Settings_light__r9uhl"};